import { useDirectoryChannels } from '@frontend/shared/hooks/useDirectory';

export function SearchEmpty({ hasFilter }: { hasFilter: boolean }) {
  const channels = useDirectoryChannels({
    requireQbInChannel: true,
    excludeDeleted: true,
  });

  if (hasFilter) {
    return (
      <div className="text-center pt-[200px]">
        <p className="text-[32px] leading-[35px] font-bold">No results</p>
      </div>
    );
  }

  return (
    <div className="text-center pt-[200px]">
      <p className="text-lg font-bold">No saved answers yet.</p>
      <p className="mt-4">
        Go to Slack and share some know-how
        <br />
        or ask a question in one of these channels.
      </p>
      <div className="mt-5">
        {channels.map((c) => (
          <a
            className="block text-blue-500 hover:underline mt-2"
            key={c.id}
            href={`https://slack.com/app_redirect?channel=${c.id}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            #{c.name}
          </a>
        ))}
      </div>
    </div>
  );
}
